import Patient from "@/models/patient";

export default class Period {
    private MONDAY = 1;
    private FRIDAY = 5;
    public id: number;
    public name: string;
    public dateFrom: string;
    public dateTo: string;
    public patients?: Patient[];
    public availability: number;
    public occupancy: number;
    public statistics: string;

    constructor({id, name, dateFrom, dateTo, patients, availability, occupancy}: any) {
        this.id = id;
        this.name = name;
        this.dateFrom = dateFrom || this.getDay(this.MONDAY);
        this.dateTo = dateTo || this.getDay(this.FRIDAY);
        this.patients = patients;
        this.availability = availability;
        this.occupancy = occupancy;
        this.statistics = `${this.availability !== undefined && this.availability > 0 ? Math.round(this.occupancy*0.25/this.availability*100) : 0}% `;
    }

    public getDay(d: number): string {
        const today = new Date();
        const nextDay = new Date();
        nextDay.setDate((today.getDate() + (d + 7 - today.getDay()) % 7));
        return nextDay.toISOString().substr(0, 10);
    }
}
